/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ISitePickerViewProps } from './site-picker';

export default (props: ISitePickerViewProps) => {
    return (
        <React.Fragment>
            {_renderSitePicker(props)}
        </React.Fragment>
    );
};

const _renderDesktopView = (props: ISitePickerViewProps) => {
    const { SitePickerMenu, SitePickerMenuSpan } = props;
    return (
        <React.Fragment>
            <Node {...SitePickerMenu} onClick={props.renderSiteOptions}>
                {props.config.heading?.text}
                <Node {...SitePickerMenuSpan} />
            </Node>
            {props.siteOptionsState ? _renderSiteOptionsList(props) : null}
        </React.Fragment>
    );
};

const _renderSiteOptionsList = (props: ISitePickerViewProps): React.ReactNode => {
    const { SitePickerMenuList,
        SitePickerMenuListItem,
        SitePickerMenuListItemArray,
    } = props;
    const options = SitePickerMenuListItemArray!.map((item, index) => {
        return (
            <Node {...SitePickerMenuListItem} key={index}>
                {item}
            </Node>
        );
    }
    );
    return (
        <Node {...SitePickerMenuList} onMouseLeave={props.resetSiteOptionsState}>
            {options}
        </Node>
    );
};

const _renderMobileView = (props: ISitePickerViewProps): React.ReactNode => {
    const { SitePickerMobileContainer } = props;
    return (
        <Node {...SitePickerMobileContainer} onClick={props.renderSiteOptions}>
            <div>
                {props.SitePickerMenuListItemArray?.map((item, index) => {
                    return (
                        <div key={index}>{item}</div>
                    );
                })}
            </div>
        </Node>
    );
};

const _renderSitePicker = (props: ISitePickerViewProps): React.ReactNode => {
    const { isMobileView, SitePicker } = props;
    return (
        <Module {...SitePicker}>
            {isMobileView ? _renderMobileView(props) : _renderDesktopView(props)}
        </Module>
    );
};